import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://lws-server-for-assignmentss.herokuapp.com/',
  }),
  tagTypes: ['todos'],
  endpoints: (builder) => ({
    getToDos: builder.query({
      query: () => '/todos',
      keepUnusedDataFor: 600,
      providesTags: ['todos'],
    }),
    addToDos: builder.mutation({
      query: (data) => ({
        url: '/todos',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['todos'],
    }),
    deleteToDo: builder.mutation({
      query: (id) => ({
        url: `/todos/${id}`,
        method: 'Delete',
      }),
      invalidatesTags: ['todos'],
    }),
    changeStatusToDo: builder.mutation({
      query: ({ id, data }) => ({
        url: `/todos/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['todos'],
    }),
    changeColorToDo: builder.mutation({
      query: ({ id, data }) => ({
        url: `/todos/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['todos'],
    }),
    changeTextToDo: builder.mutation({
      query: ({ id, data }) => ({
        url: `/todos/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['todos'],
    }),
    completeAllTask: builder.mutation({
      query: ({ id, data }) => ({
        url: `/todos/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['todos'],
    }),
    inCompleteAllTask: builder.mutation({
      query: ({ id, data }) => ({
        url: `/todos/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['todos'],
    }),
  }),
});

export const {
  useGetToDosQuery,
  useAddToDosMutation,
  useDeleteToDoMutation,
  useChangeStatusToDoMutation,
  useChangeColorToDoMutation,
  useCompleteAllTaskMutation,
  useChangeTextToDoMutation,
  useInCompleteAllTaskMutation,
} = apiSlice;
